import { render } from "./AddPayrollEarnings.vue?vue&type=template&id=6ac9ccc5&scoped=true"
import script from "./AddPayrollEarnings.vue?vue&type=script&lang=js"
export * from "./AddPayrollEarnings.vue?vue&type=script&lang=js"

import "./AddPayrollEarnings.vue?vue&type=style&index=0&id=6ac9ccc5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac9ccc5"]])

export default __exports__